import type {
  Fields,
  MutationCreateTemplateArgs,
  Template,
} from '@tribeplatform/gql-client/types'

import {
  useMutation,
  UseMutationOptions,
} from '../../lib/react-query/useMutation.js'
import { useQueryClient } from '../../lib/react-query/useQueryClient.js'
import { useTribeClient } from '../../useTribeClient.js'
import { getTemplatesKey } from '../../utils/keys/template.key.js'

export const useCreateTemplate = (options?: {
  fields?: Fields.TemplateFields
  useMutationOptions?: UseMutationOptions<
    Template,
    Error,
    MutationCreateTemplateArgs
  >
}) => {
  const { useMutationOptions, fields = 'basic' } = options || {}
  const { client } = useTribeClient()
  const queryClient = useQueryClient()

  return useMutation<Template, Error, MutationCreateTemplateArgs>(
    variables =>
      client.mutation({
        name: 'createTemplate',
        args: {
          fields,
          variables,
        },
      }),
    {
      onSettled: () => {
        queryClient.invalidateQueries(getTemplatesKey())
      },
      ...useMutationOptions,
    },
  )
}
